import React, { useState, useEffect, useContext } from "react";
import "./Schedule.css";
import { useNavigate, useParams } from "react-router-dom";
import SearchArea from "../../components/SearchArea";
import {
  calendarKey,
  routeCalendarDate,
  formatToronto,
} from "../../utils/TorontoTime";

// image
import CarIcon from "../../assets/car_icon.png";

import Selector from "../../components/Selector";
import { getData, postData } from "../../api";
import Spinner from "../../components/Spinner";
import { AuthContext } from "../../context/AuthContext";
import Alert from "../../utils/Alert";

import NoContent from "../../components/NoContent";
import { CalculateTime, addTimeToDate } from "../../utils/TimeCalculations";
import { WithInPickUpArea } from "../../constant/Config";

export default function Schedule(props) {
  const { authDetails } = useContext(AuthContext);
  const navigate = useNavigate();
  const routeParams = useParams();
  const [scheduleInfo, setscheduleInfo] = useState({
    ...routeParams,
    date: routeCalendarDate(routeParams.date),
    adults: parseInt(routeParams.adults),
    luggage: parseInt(routeParams.luggage),
  });
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState({
    from: false,
    to: false,
    adults: false,
    pickup: false,
    dropoff: false,
    customLocation: false,
  });

  const [cities, setcities] = useState([]);
  const [locations, setlocations] = useState({
    pickup: [],
    dropoff: [],
    rides: [],
  });
  const [selectedRideId, setselectedRideId] = useState(null);
  const rides = locations.rides.map((ride) => ({
    ...ride,
    totalPrice:
      ride.stops.price * scheduleInfo.adults +
      (scheduleInfo.luggage > 0
        ? ride.luggage[0] + ride.luggage[1] * (scheduleInfo.luggage - 1)
        : 0),
  }));
  const selected = rides.find((ride) => ride._id === selectedRideId);
  const selectedRide = selected
    ? {
        id: selected._id,
        time: selected.pickupAt,
        price: selected.totalPrice,
        bookingsLeft: selected.seatsLeft,
        serviceDate: selected.serviceDate,
      }
    : { id: 0, bookingsLeft: 0 };
  const [pointLocation, setpointLocation] = useState({
    pickup: "",
    dropoff: "",
    customLocation: "",
  });

  const getCityName = (id) => {
    return cities.filter((item) => item.id == id).length > 0
      ? cities.filter((item) => item.id == id)[0]
      : "";
  };

  const travelDate = calendarKey(scheduleInfo.date);
  const { from, to } = scheduleInfo;
  const [availabilityRefresh, setAvailabilityRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    setloading(true);
    setselectedRideId(null);
    const load = async () => {
      const [cityData, pickupData, dropoffData, rideData] = await Promise.all([
        getData("/city/cities", false),
        postData("/location/locations", { city_id: from }, false),
        postData("/location/locations", { city_id: to }, false),
        getData(`/ride/stop/${from}/${to}?date=${travelDate}`, false),
      ]);
      if (!active) return;
      const pickup = (pickupData || []).map((item) => ({
        id: item._id,
        item: item.location,
      }));
      const dropoff = (dropoffData || []).map((item) => ({
        id: item._id,
        item: item.location,
      }));
      setcities(
        (cityData || []).map((item) => ({ id: item._id, item: item.city })),
      );
      setlocations({ pickup, dropoff, rides: rideData || [] });
      setpointLocation({
        pickup: pickup[0]?.id || "",
        dropoff: dropoff[0]?.id || "",
        customLocation: "",
      });
      setloading(false);
    };
    load();
    return () => {
      active = false;
    };
  }, [from, to, travelDate, availabilityRefresh]);

  const formatPickupTime = (value) => formatToronto(value, "hh:mm A");

  const onConfirm = async () => {
    if (validation()) {
      setloading(true);
      let payload = {
        from: {
          location_id: pointLocation.pickup,
          city_id: scheduleInfo.from,
          customLocation:
            pointLocation.pickup === WithInPickUpArea
              ? pointLocation.customLocation
              : "",
        },
        to: {
          location_id: pointLocation.dropoff,
          city_id: scheduleInfo.to,
          customLocation:
            pointLocation.dropoff === WithInPickUpArea
              ? pointLocation.customLocation
              : "",
        },
        ride_id: selectedRide.id,
        price: selectedRide.price,
        ScheduledToTime: selectedRide.time,
        serviceDate: selectedRide.serviceDate,
        adult: scheduleInfo.adults,
        luggage: scheduleInfo.luggage,
      };
      if (authDetails.isAuthenticated) {
        if (authDetails.type === "user") {
          const response = await postData("/booking/create", payload);
          if (response) {
            Alert(
              "Booking received",
              "We’ve reserved your seats. Your booking is pending; we’ll confirm once a driver is assigned.",
              () => {
                navigate("/");
              },
              false,
              () => {},
              () => {},
              true,
              "Ok",
            );
          } else {
            setAvailabilityRefresh((value) => value + 1);
          }
        } else {
          Alert(
            "Error",
            "Please login as user to book ride",
            () => {
              navigate("/login");
            },
            false,
            () => {},
            () => {},
            true,
            "Ok",
          );
        }
      } else {
        Alert(
          "U are not loggedin",
          "Please login to confirm booking",
          () => {
            navigate("/login", { state: payload });
          },
          false,
          () => {},
          () => {},
          true,
          "Ok",
        );
      }

      setloading(false);
    }
  };
  const validation = () => {
    let errorDict = {};
    let seatsAvailable =
      selectedRide.bookingsLeft >= scheduleInfo.adults ? true : false;
    console.log(seatsAvailable);
    if (pointLocation.pickup === "") errorDict = { ...errorDict, pickup: true };
    else errorDict = { ...errorDict, pickup: false };
    if (pointLocation.dropoff === "")
      errorDict = { ...errorDict, dropoff: true };
    else errorDict = { ...errorDict, dropoff: false };
    if (
      (pointLocation.pickup === "6564e158f3d3c3b55fe5854b" ||
        pointLocation.dropoff === "6564e158f3d3c3b55fe5854b") &&
      pointLocation.customLocation === ""
    )
      errorDict = { ...errorDict, customLocation: true };
    else errorDict = { ...errorDict, customLocation: false };
    if (selectedRide.id == 0)
      Alert(
        "Please select the ride",
        "To confirm the booking you need to select a ride",
        () => {},
        false,
        () => {},
        () => {},
        true,
        "Ok",
      );
    if (!seatsAvailable)
      Alert(
        "Sorry, Seats not available",
        "Required number of seats not available for this date",
        () => {},
        false,
        () => {},
        () => {},
        true,
        "Ok",
      );

    seterror({ ...error, ...errorDict });
    if (
      !errorDict.pickup &&
      !errorDict.dropoff &&
      !errorDict.adults &&
      !errorDict.customLocation &&
      selectedRide.id !== 0 &&
      seatsAvailable
    )
      return true;
    else return false;
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="schedule-page">
          <SearchArea
            locationsFrom={cities.filter(
              (item) => item.id == scheduleInfo.from,
            )}
            locationsTo={cities.filter((item) => item.id == scheduleInfo.to)}
            locations={cities}
            scheduleInfo={scheduleInfo}
            setscheduleInfo={setscheduleInfo}
            error={error}
          />
          <div className="schedule-content">
            <div className="rides">
              {!rides.some((ride) => ride.isAvailable) && (
                <NoContent content={"No Rides Available"} />
              )}
              {rides.map(
                (ride, index) =>
                  ride.isAvailable && (
                    <div
                      className={`ride ${
                        selectedRide.id === ride._id ? "selected" : ""
                      }`}
                      key={ride._id}
                      onClick={() => setselectedRideId(ride._id)}
                    >
                      <div className="ride-content">
                        <div className="from">
                          <div className="time">
                            {formatPickupTime(ride.pickupAt)}
                          </div>
                          <div className="location">
                            {getCityName(scheduleInfo.from).item}
                          </div>
                        </div>
                        <div className="travel-time">
                          <img src={CarIcon} />
                          <span>{CalculateTime(ride.stops.travelTime)}</span>
                        </div>
                        <div className="to">
                          <div className="time">
                            {formatPickupTime(
                              addTimeToDate(
                                ride.pickupAt,
                                ride.stops.travelTime,
                              ),
                            )}
                          </div>
                          <div className="location">
                            {getCityName(scheduleInfo.to).item}
                          </div>
                        </div>
                      </div>
                      <div className="price-section">
                        <div className="price">
                          <span>Price : </span> ${ride.totalPrice}
                        </div>
                        <div className="bookings-left">{`(${ride.seatsLeft} seats left)`}</div>
                      </div>
                    </div>
                  ),
              )}
            </div>
            <div className="ride-details">
              <div className="pickup">
                <Selector
                  mainTitle={"Pick-up Location"}
                  title={"Leaving from"}
                  items={locations.pickup}
                  initialSelection={[
                    locations.pickup.length > 0 ? locations.pickup[0] : {},
                  ]}
                  selectedItem={(e) =>
                    setpointLocation({
                      ...pointLocation,
                      pickup: e.length > 0 ? e[0].id : "",
                    })
                  }
                  isError={error.pickup}
                />
              </div>
              <div className="dropoff">
                <Selector
                  mainTitle={"Drop-off Location"}
                  title={"Going to"}
                  items={locations.dropoff}
                  initialSelection={[
                    locations.dropoff.length > 0 ? locations.dropoff[0] : {},
                  ]}
                  selectedItem={(e) =>
                    setpointLocation({
                      ...pointLocation,
                      dropoff: e.length > 0 ? e[0].id : "",
                    })
                  }
                  isError={error.dropoff}
                />
              </div>
              {(pointLocation.pickup === "6564e158f3d3c3b55fe5854b" ||
                pointLocation.dropoff === "6564e158f3d3c3b55fe5854b") && (
                <div
                  className={`custom-location ${
                    error.customLocation ? "error" : ""
                  }`}
                >
                  <input
                    value={pointLocation.customLocation}
                    placeholder="Enter the location"
                    onChange={(e) =>
                      setpointLocation({
                        ...pointLocation,
                        customLocation: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              {/* {pointLocation.dropoff === "6564e158f3d3c3b55fe5854b" && (
                <div className="custom-location">
                  <input
                    placeholder="Enter the dropoff location"
                    onChange={(e) =>
                      setpointLocation({
                        ...pointLocation,
                        type: "dropoff",
                        customLocation: e.target.value.trim(),
                      })
                    }
                  />
                </div>
              )} */}
              <button className="confirm-booking" onClick={() => onConfirm()}>
                Request booking
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
